/**
 * Retrieves the menu data from localStorage.
 * @returns {Array} An array of menu objects, or an empty array if not found or invalid.
 */
const getMenus = () => {
  try {
    const menus = localStorage.getItem('menus');
    if (!menus) return [];
    const parsedMenus = JSON.parse(menus);
    return Array.isArray(parsedMenus) ? parsedMenus : [];
  } catch (error) {
    console.error('Error parsing menus from localStorage:', error);
    return [];
  }
};

/**
 * Checks if the user has access to a specific module based on menu data.
 * @param {string} moduleName - The name of the module to check.
 * @returns {boolean} True if the module is accessible, false otherwise.
 */
const hasModuleAccess = (moduleName) => {
  if (typeof moduleName !== 'string') return false;
  const menus = getMenus();
  return menus.some(menu => menu.name && menu.name.toLowerCase() === moduleName.toLowerCase());
};

/**
 * Retrieves the submenus for a given module.
 * @param {string} moduleName - The name of the module.
 * @returns {Array<string>} An array of submenu names in lowercase, or an empty array if the module is not found.
 */
const getSubMenus = (moduleName) => {
  if (typeof moduleName !== 'string') return [];
  const menus = getMenus();
  const module = menus.find(menu => menu.name && menu.name.toLowerCase() === moduleName.toLowerCase());
  return module && Array.isArray(module.menu) 
    ? module.menu
        .filter(submenu => submenu.name)
        .map(submenu => submenu.name.toLowerCase())
    : [];
};

export { getMenus, hasModuleAccess, getSubMenus };